import * as React from "react";
import {AudioPlayer} from "./AudioPlayer";

export interface IAudioPlayerProps {
}
export interface IAudioPlayerState {
}


export class AudioPlayerComponent extends React.Component<IAudioPlayerProps, any> {
    private slider: HTMLInputElement;
    constructor(props: IAudioPlayerProps) {
        super(props);
        
        this.state = {
            playing: AudioPlayer.isPlaying()
        };
        this.audioChanged=this.audioChanged.bind(this);
    }
    audioChanged(arg:string) {
        //console.log("audio player change: " + arg);
        this.forceUpdate();
    }
    componentWillMount(): void {
        AudioPlayer.onChange(this.audioChanged);
    }

    componentWillUnmount(): void {
        AudioPlayer.removeOnChange(this.audioChanged);
    }

    render() {
        let playPause = "play";
        if (AudioPlayer.isPlaying())
            playPause = "pause";
        const playPauseCss = "glyphicon glyphicon-" + playPause;
        const currentAudioFile = AudioPlayer.getCurrentTrack();
        return (
            <div id="audioplayer">
                <i className="glyphicon glyphicon-step-backward" onClick={() => AudioPlayer.skip(-1)}></i>
                <i className={playPauseCss} onClick={() => AudioPlayer.togglePlay()}></i>
                <i className="glyphicon glyphicon-step-forward" onClick={() => AudioPlayer.skip(1)}></i>
                <span className="title" title={currentAudioFile.title}>{currentAudioFile.title}</span>
                <div className="slidecontainer">
                    <input type="range" min="0" max="100" defaultValue={(AudioPlayer.volume() * 100).toString()} className="slider" onChange={() => this.setVolume()} ref={(ref) => this.slider = ref} />
                </div>
            </div>
        );
    }

    setVolume() {
        AudioPlayer.volume(parseInt(this.slider.value) / 100);
    }
}
